const React = require('react');
const map = require('mn-utils/map');
const IconButton = require('@material-ui/core/IconButton').default;
const Ripple = require('../../../../../dumb/Ripple');
const CloseIcon = require('../../../../../icons/Close');


module.exports = (props) => {
  const {
    currentIndex,
    clicked,
  } = props;
  return (
    <div className="cfx mh-5 (lt|ph5|mb10)>1">
      {map(props.items, (item, i) => {
        const {
          state,
          disabled,
        } = item;
        const active = i === currentIndex;
        return (
          <div
            key={i}
          >
            <Ripple
              className={`w124 h45 layoutRow fhaB fvaC r9 ov olN usN tdN
                bs b1 bc0 dn o70 o100:h ((bg|bc)5B47FF|o100).active
                bcF00.invalid bgF00.invalid.active`
                + (active ? ' active' : '')
                + (clicked && disabled ? ' invalid' : '')}
              disabled={active}
              onClick={() => {
                props.onChange(i);
              }}
            >
              <div className="layoutRow fhaC fvaC pl7 wmin0">
                <div
                  className="layoutRow fhaC fvaC sq(|min)16 ov r
                    f10 fw3 lh lts0em tc c0 (bgF|c5B47FF)<2.active
                    cF00<2.invalid*2"
                >{i + 1}</div>
                <div
                  className="pl5 f10 fw3 lh lts0em tl ov tov ws c0
                    cF00<2.invalid (cF|pr7)<2.active*2"
                >{state.fullname || 'UBO/shareholder'}</div>
              </div>
              <IconButton
                className="rlv*2 p8*2 c0*2 cF<1.active*2 z1 dn o70 o100:h"
                onClick={() => {
                  props.onRemove(i);
                }}
              >
                <CloseIcon className="w16"/>
              </IconButton>
            </Ripple>
          </div>
        );
      }, [])}
      <div>
        <Ripple
          className="wmin124 h45 layoutRow fhaC fvaC r9 ov olN usN tdN
            dn bg01:h"
          onClick={props.onCreate}
        >
          <div
            className="pl5 f10 fw3 lh lts0em tl c0"
          >+ UBO/shareholder</div>
        </Ripple>
      </div>
    </div>
  );
};
